import { Component, OnInit, AfterViewInit } from '@angular/core';
import { locale as en } from '../i18n/en'
import { locale as fr } from '../i18n/fr'
import { locale as de } from '../i18n/de'
import { locale as pt } from '../i18n/pt'
import { locale as sp } from '../i18n/sp'
import { CoreTranslationService } from '@core/services/translation.service';
import Stepper from 'bs-stepper';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PronosticoService } from '../services/pronostico.service';
import { PrediccionesRealizadas } from '../models/predicciones-realizadas';
import { EvaluarPrediccionRequest } from '../models/evaluar-prediccion-request';
import { PrediccionEvaluada } from '../models/prediccion-evaluada';


@Component({
  selector: 'app-prediccion',
  templateUrl: './prediccion.component.html',
  styleUrls: ['./prediccion.component.scss']
})
export class PrediccionComponent implements OnInit, AfterViewInit {

  metodos = [
    { value: 'random-walk', label: '1.- RandomWalk', metodoPrediccion: 'RandomWalk' },
    { value: 'frequency-weighted', label: '2.- FrequencyWeighted', metodoPrediccion: 'FrequencyWeighted' },
    { value: 'gap', label: '3.- Gap', metodoPrediccion: 'Gap' },
    { value: 'hybrid', label: '4.- Hybrid', metodoPrediccion: 'Hybrid' },
    { value: 'noise-injected', label: '5.- NoiseInjected', metodoPrediccion: 'NoiseInjected' },
    { value: 'union', label: '6.- Union', metodoPrediccion: 'CombinarPredicciones' },
    { value: 'mersenne-twister', label: '7.- MersenneTwister', metodoPrediccion: 'mersenne-twister' },
    { value: 'noise-injected-v2', label: '8.- NoiseInjectedV2', metodoPrediccion: 'NoiseInjectedV2' }
  ];

  metodoSeleccionado = this.metodos[0]; // aquí selecciona el primero (RandomWalk)
  MetodoPrediccionSeleccionado = this.metodos[0].metodoPrediccion;

  juegoSeleccionado: string = 'MELATE'; // valor por defecto
  cantidadEjecuciones: number = 1;
  fechaSeleccionada: string = ''; // bound con el input type="date"  
  //metodoSeleccionado: string = 'random-walk'; // valor por defecto
  resultadoPrediccion: string;
  prediccionesEvaluadas: PrediccionEvaluada[] = [];
  resultadoJuego: string;
  bAlmacenarEnLaBase: boolean = false;
  bRecuperarProcesoPrevio: boolean = false;
  inicioEjecuciones: number = 1;
  alertDanger: boolean = false;
  mensajeDanger: string = "Mensaje";
  alertSuccess: boolean = false;
  mensajeSuccess: string = "Mensaje";
  ultimaPrediccion : PrediccionEvaluada;

  bEjecutandoPredicciones: boolean = false;
  bDetenerPredicciones: boolean = false;
  


  constructor(
        private _coreTranslationService: CoreTranslationService,
        private pronosticoService: PronosticoService,
        private fb: FormBuilder
  ) {
        this._coreTranslationService.translate(en, fr, de, pt, sp);
  }

  ngOnInit(): void {
    //this.obtenerPrediccionMelate();
    //this.obtenerPrediccionMelateRetro();
  }


  ngAfterViewInit(): void {
    const element = document.querySelector('#stepper1');
    if (element) {
    } else {
    }
  }  

  onMetodoChange(metodo: any) {
    this.MetodoPrediccionSeleccionado = metodo.metodoPrediccion;
  }

  private generarIdentificador(): string {
    return Math.random().toString(36).substring(2, 10) + Date.now().toString(36);
  }

  obtenerMordredPrediccionUnionPost() {
    this.bDetenerPredicciones = false;
    this.bEjecutandoPredicciones = true;
    if(this.fechaSeleccionada.length == 0)
    {
        this.alertDanger = true;
        this.mensajeDanger = 'Seleccione la fecha';
        return;
    }

    this.alertDanger = false;

    this.resultadoPrediccion = ''; // limpiar antes de iniciar
    let identificadorCiclo = this.generarIdentificador();
    if(this.ultimaPrediccion?.identificador != "")
      identificadorCiclo = this.ultimaPrediccion?.identificador;

    let fechaFormateada = new Date(this.fechaSeleccionada)
      .toISOString()
      .split('T')[0]; // -> "yyyy-mm-dd"
    let i = 1;

    if(this.bRecuperarProcesoPrevio)
      i = this.inicioEjecuciones;

    const ejecutar = () => {
      this.bEjecutandoPredicciones = true;
      if (i > this.cantidadEjecuciones) return; // terminó
      if (this.bDetenerPredicciones) return; // terminó

      // Preparar el modelo a enviar
      const modelo: PrediccionesRealizadas = {
        id: 0,
        numero: i,
        total: this.cantidadEjecuciones,
        maximoValor:  this.juegoSeleccionado == 'MELATE' ? 56 : 39, // el valor fijo que antes iba en la URL
        identificador: identificadorCiclo,
        fechaConcurso: fechaFormateada,
        prediccion: '',
        juego: this.juegoSeleccionado,
        bAlmacenarEnLaBase: this.bAlmacenarEnLaBase
      };

      this.pronosticoService.obtenerMordredPrediccionPost(modelo,this.metodoSeleccionado.value).subscribe(
        (response: any) => {
          //this.resultadoPrediccion =
            //`${i}/${this.cantidadEjecuciones} ${JSON.stringify(response)}\n`;

          this.resultadoPrediccion = JSON.parse(JSON.stringify(response));

          i++;
          setTimeout(ejecutar, 333); // esperar 1/3 seg y continuar
        },
        (error) => {
          console.error('Error al obtener Predicción:', error);

          this.alertDanger = true;
          this.mensajeDanger = error || 'Ocurrió un error';

          i++;
          setTimeout(ejecutar, 333); // aunque falle, sigue con el siguiente

        }
      );
    };

    ejecutar(); // iniciar la secuencia
    this.bEjecutandoPredicciones = false;
  }
  detenerPredicciones(){
    this.bEjecutandoPredicciones = false;
    this.bDetenerPredicciones = true;
  }


  obtenerPatronPredicciones() {

    if(this.fechaSeleccionada.length == 0)
    {
        this.alertDanger = true;
        this.mensajeDanger = 'Seleccione la fecha';
        return;
    }

    this.alertDanger = false;
    this.resultadoPrediccion = ''; // limpiar antes de iniciar


    let fechaFormateada = new Date(this.fechaSeleccionada)
      .toISOString()
      .split('T')[0]; // -> "yyyy-mm-dd"

    const bodyPatron: EvaluarPrediccionRequest = {
      FechaCierre: fechaFormateada,
      Juego: this.juegoSeleccionado,
      Metodo: this.metodoSeleccionado.metodoPrediccion,
      Combinacion: ""
    };

    this.pronosticoService.obtenerPatronPredicciones(bodyPatron)
      .subscribe(
        res => this.resultadoPrediccion = JSON.parse(JSON.stringify(res)),
        error => {
          this.alertDanger = true;
          this.mensajeDanger = error || 'Ocurrió un error';
        }
      );

  }

  consultarUltimaPrediccion() {

    if(this.fechaSeleccionada.length == 0)
    {
        this.alertDanger = true;
        this.mensajeDanger = 'Seleccione la fecha';
        return;
    }

    this.alertDanger = false;
    this.resultadoPrediccion = ''; // limpiar antes de iniciar


    let fechaFormateada = new Date(this.fechaSeleccionada)
      .toISOString()
      .split('T')[0]; // -> "yyyy-mm-dd"

    const bodyPatron: EvaluarPrediccionRequest = {
      FechaCierre: fechaFormateada,
      Juego: this.juegoSeleccionado,
      Metodo: this.metodoSeleccionado.metodoPrediccion,
      Combinacion: ""
    };

    this.pronosticoService.consultarUltimaPrediccion(bodyPatron)
      .subscribe(
        res =>{
          this.resultadoPrediccion = JSON.parse(JSON.stringify(res))
          this.ultimaPrediccion = res;
          if(res != null && this.bRecuperarProcesoPrevio)
          {
            this.inicioEjecuciones = res.numero+1;
            this.cantidadEjecuciones = res.total;
          }
        },
        error => {
          this.alertDanger = true;
          this.mensajeDanger = error || 'Ocurrió un error';
        }
      );

  }

  consultarEfectividad() {

    if(this.fechaSeleccionada.length == 0)
    {
        this.alertDanger = true;
        this.mensajeDanger = 'Seleccione la fecha';
        return;
    }

    this.alertDanger = false;
    const body: EvaluarPrediccionRequest = {
      FechaCierre: this.fechaSeleccionada,
      Juego: this.juegoSeleccionado,
      Metodo: "",
      Combinacion: this.resultadoJuego
    };

    this.pronosticoService.evaluarEfectividadPredicciones(body)
      .subscribe(
        res => this.prediccionesEvaluadas = res,
        error => {
          this.alertDanger = true;
          this.mensajeDanger = error || 'Ocurrió un error';
        }
      );
  }

}
